import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'

import Header from 'app/BCKSPage/components/Header'
import { SelectionSteps } from '../blocks/SelectionSteps'
import AndroidHandler from 'utils/androidHandler'

export const BCKSInvitationFinal = () => {
  const androidHandler = AndroidHandler()
  const router = useRouter()

  const handleBackToHome = () => {
    if (androidHandler.enabled) androidHandler.backToHomepage(router.back)
    router.replace('/home')
  }

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header
        withRightActionButton={false}
        title="Proses Seleksi"
        onBackClick={handleBackToHome}
      />
      <div className="p-4 h-full bg-surface-subdued">
        <SelectionSteps />

        <Button
          variant="ghost"
          fullWidth
          className="mt-4"
          onClick={() => handleBackToHome()}
        >
          Kembali ke Beranda
        </Button>
      </div>
    </div>
  )
}
